export function setInstantInterval(f: () => void, t: number): () => number {
  return function instantInterval(): number {
    f();
    return window.setInterval(f, t);
  };
}
